import React from "react";
import { func } from "prop-types";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import QRCode from "qrcode.react";
import { isIE } from 'react-device-detect';

// Strings
import { getMessage } from "CONFIG/i18n";

// Styles
import "./AdminDashboard.less";
import modalScrollBar from "../../ModalScrollBar/ModalScrollBar";

class QRPopUp extends React.Component {
  static propTypes = {
    handleYesClick: func,
    handleNoClick: func
  };
  constructor(props) {
    super(props);
    this.state = {};
  }

  generateQrCode = (isClose = false) => {

    let canvas = document.getElementById("HpQrcode");
    let qrcodeDownload = document.getElementById("qrcodeDownload");

    if (isIE) { // IE10+
      var blob = canvas.msToBlob();
      navigator.msSaveBlob(blob, "QRCode.png");
    }
    else if(qrcodeDownload) {
      qrcodeDownload.href = canvas.toDataURL("image/png");
      qrcodeDownload.download = "QRCode.png";
      qrcodeDownload.click();
    }

    isClose ? this.props.showQRPopUp(false) : null;
  };

  renderButtons = () => {
    return (
      <div className="permissionButtons">
        <Button
          onClick={() => {
            this.generateQrCode(true);
          }}
          className="buttons customBtn blinkBtn"
        >
          {getMessage("DOWNLOAD")}
        </Button>
      </div>
    );
  };

  render() {
    return (
      <Modal
        isOpen={this.props.show}
        className="addOrganisationModal userAddModal qrcodeModal"
        toggle={() => {
          this.props.showQRPopUp(false);
        }}
      >
        <ModalHeader className="popupHeader displayFlex">
          {getMessage("QR_CODE")}
        </ModalHeader>
        <ModalBody>
          <QRCode
            includeMargin={true}
            id="HpQrcode"
            className="HpQrcode"
            data-toggle="tooltip"
            title={getMessage("CLICK_TO_DOWNLOAD")}
            onClick={() => this.generateQrCode()}
            value={this.props.qrurl}
          />
          <div>
            <a target="_blank" href={this.props.qrurl}>
              {this.props.qrurl}{" "}
            </a>
          </div> 
        </ModalBody>
        <ModalFooter className="permissionButtons">
          {this.renderButtons()}
          <a id="qrcodeDownload" />
        </ModalFooter>
      </Modal>
    );
  }
}

export default modalScrollBar(QRPopUp);
